import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postHide = (params) => {
    return axios.post(`${backendHost}/api/admin/cashiers/hide`, params);
};

export {
    postHide
}